import React from 'react'
import './SpinnerPage.css'
import { ColorRing } from  'react-loader-spinner'

const SpinnerPage = () => {
  return (
    <div className="spiner">
      <div>
        <ColorRing
          visible={true}
          height="80"
          width="80"
          ariaLabel="blocks-loading"
          wrapperStyle={{}}
          wrapperClass="blocks-wrapper"
          colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
        />
      </div>
    </div>
  );
}

export default SpinnerPage